import React, { useState } from 'react';
import { FileTextIcon, CalendarIcon } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
interface PdfExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (dateFrom: string | null, dateTo: string | null, status: string | null, patientId: string | null) => void | Promise<void>;
  title: string;
  isExporting?: boolean;
  // Opciones para los filtros adicionales de estado y paciente.
  statusOptions?: {
    value: string;
    label: string;
  }[];
  patientOptions?: {
    value: string;
    label: string;
  }[];
}
export function PdfExportModal({
  isOpen,
  onClose,
  onExport,
  title,
  isExporting = false,
  statusOptions = [],
  patientOptions = []
}: PdfExportModalProps) {
  const [useDateRange, setUseDateRange] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState('');
  const [patientId, setPatientId] = useState('');
  const handleClose = () => {
    if (isExporting) return;
    onClose();
  };
  const handleExportAll = async () => {
    await onExport(null, null, status || null, patientId || null);
  };
  const handleExportRange = async () => {
    if (!dateFrom || !dateTo) return;
    await onExport(dateFrom, dateTo, status || null, patientId || null);
  };
  return <Modal isOpen={isOpen} onClose={handleClose} title={title} size="sm" icon={<FileTextIcon className="w-4 h-4" data-id="element-6431" data-mp="q6130rdp8lxj" />} accentColor="rose" footer={<div className="flex items-center justify-end gap-2" data-id="element-6432" data-mp="uzn55pm8l7f3">
          <Button variant="ghost" onClick={handleClose} disabled={isExporting} data-id="element-6433" data-mp="zx5f9jbzpsoo">
            Cancelar
          </Button>
          {useDateRange ? <Button variant="primary" onClick={handleExportRange} isLoading={isExporting} disabled={!dateFrom || !dateTo} data-id="element-6434" data-mp="140bmouau9pwq">
          
              Exportar rango
            </Button> : <Button variant="primary" onClick={handleExportAll} isLoading={isExporting} data-id="element-6435" data-mp="34z5dod9yxn32">
              Exportar todo
            </Button>}
        </div>} data-id="element-6430" data-mp="l7zkc7k6qoml">
      
      <div className="space-y-4" data-id="element-6436" data-mp="3ert8j2he1gz5">
        <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-6437" data-mp="3esvztbimhlfl">
          Elige si deseas exportar todos los registros o filtrar por un rango de fechas antes de generar el archivo PDF.
        </p>

        <div className="flex gap-2 p-1 bg-gray-100 dark:bg-white/[0.06] rounded-xl" data-id="element-6438" data-mp="3or1yzld1odgr">
          <button type="button" onClick={() => setUseDateRange(false)} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${!useDateRange ? 'bg-white dark:bg-white/[0.12] text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-6439" data-mp="3js8kbpm0ugf0">
            
            Todos los registros
          </button>
          <button type="button" onClick={() => setUseDateRange(true)} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${useDateRange ? 'bg-white dark:bg-white/[0.12] text-gray-900 dark:text-white shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-6440" data-mp="duqw6uqxafn3">
            
            Rango de fechas
          </button>
        </div>

        {useDateRange && <div className="grid grid-cols-2 gap-3" data-id="element-6441" data-mp="3r8vjtck5znio">
            <Input label="Desde" type="date" icon={<CalendarIcon className="w-4 h-4" data-id="element-6443" data-mp="19dfc6296y4" />} value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-6442" data-mp="32mey45c39a" />
          
            <Input label="Hasta" type="date" icon={<CalendarIcon className="w-4 h-4" data-id="element-6445" data-mp="1ghvhecsl8tyu" />} value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-6444" data-mp="3m9sju6j1k7hk" />
          
          </div>}

        {statusOptions.length > 0 && <Select label="Estado de la cita" options={statusOptions} value={status} onChange={setStatus} placeholder="Todos los estados" searchable={false} data-id="element-6446" data-mp="vt2z8tyy631w" />}

        {patientOptions.length > 0 && <Select label="Paciente" options={patientOptions} value={patientId} onChange={setPatientId} placeholder="Todos los pacientes" searchable data-id="element-6447" data-mp="lwges6aj9e0e" />}
      </div>
    </Modal>;
}